import React from "react";
import { Button } from "@mui/material";
import ReplacementBox from "./ReplacementBox";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
interface ReplacementPopoverCellProps {
  sku: string;
  replacements?: Record<string, [number, number, number]>; // new data structure
  showTotalStock?: boolean;
}

export const ReplacementPopoverCell: React.FC<ReplacementPopoverCellProps> = ({
  sku,
  replacements,
  showTotalStock = false,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  // transform replacements map to array for ReplacementBox
  const replacementItems = React.useMemo(() => {
    if (!replacements) return [];

    return Object.entries(replacements)
      .map(([sku, [cs, pi, oth]]) => {
        if (cs === 0 && pi === 0 && oth === 0) return null; // skip zeros
        return {
          replaced: sku,
          replacedQty: [`${cs} cs`, `${oth} oth`, `${pi} pi`],
        };
      })
      .filter(Boolean) as { replaced: string; replacedQty: string[] }[];
  }, [replacements]);

  const replacementTotals = React.useMemo(() => {
    if (!replacements) return { totalCs: 0, totalPi: 0, totalOth: 0 };

    let totalCs = 0;
    let totalPi = 0;
    let totalOth = 0;

    Object.values(replacements).forEach(([cs, pi, oth]) => {
      totalCs += cs;
      totalPi += pi;
      totalOth += oth;
    });

    return { totalCs, totalPi, totalOth };
  }, [replacements]);

  const open = Boolean(anchorEl);
  const handleOpen = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault()
    e.stopPropagation()
    if (replacementItems.length === 0) return;
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);
  const ConfigDictionary = JSON.parse(
    localStorage.getItem("ConfigDictionary") ?? "{}"
  );
  const caseUnitLabel = ConfigDictionary?.caseUnitLabel ?? "Cs";
  const packUnitLabel = ConfigDictionary?.packUnitLabel ?? "Pc";
  const otherUnitLabel = ConfigDictionary?.otherUnitLabel ?? "Oth";
  return (
    <>
      {showTotalStock ? (
        <div onClick={handleOpen} style={{ fontSize: "12px", display: "flex", alignItems: "center" }}>
          <span style={{  cursor: "pointer" }}>
            {replacementItems.length > 0
              ? `${replacementItems.length} SKUs • ${replacementTotals.totalCs} ${caseUnitLabel} ${replacementTotals.totalOth} ${otherUnitLabel} ${replacementTotals.totalPi} ${packUnitLabel}`
              : "—"}
          </span>
          {replacementItems.length > 0 && <KeyboardArrowDownIcon sx={{fontSize: '15px', cursor: "pointer"}}/>}
        </div>
      ) : (
        <Button
          size="small"
          onClick={handleOpen}
          disabled={replacementItems.length === 0}
          variant="text"
          sx={{ fontSize: "12px" }}
        >
          <span style={{ color: "#1863C5" }}>
            {replacementItems.length > 0
              ? `${replacementItems.length} SKUs`
              : "—"}
          </span>
        </Button>
      )}

      <ReplacementBox
        anchorEl={anchorEl}
        onClose={handleClose}
        replacements={replacementItems}
        showAvailable={showTotalStock}
      />
    </>
  );
};
